module.exports = __webpack_public_path__ + "static/media/plane2.17f48e28.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/plane2.svg
 ** module id = 183
 ** module chunks = 0
 **/